// index.js
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client'; // ✅ cambiamo qui
import './index.css';
import App from './App';
import Navbar from './navbar';
import Footer from './footer-bs';
import CookieConsent from "react-cookie-consent";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './i118n/i118n';

const noFooterRoutes = ['/GeoData', '/sHapp', '/archive', '/billing', '/shapp_insdata','/area_download',
        '/wms','/ves_cpt','/ves_borehole'];

function Root() {
  const [showFooter, setShowFooter] = useState(!noFooterRoutes.includes(window.location.pathname));

  useEffect(() => {
    // Funzione per aggiornare lo stato quando cambia il percorso
    const checkRoute = () => {
      setShowFooter(!noFooterRoutes.includes(window.location.pathname));
    };

    // Controlla immediatamente all'avvio
    checkRoute();

    // Ascolta gli eventi di navigazione
    window.addEventListener('popstate', checkRoute);

    // Osserva pushState e replaceState
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function(...args) {
      originalPushState.apply(this, args);
      checkRoute();
    };

    window.history.replaceState = function(...args) {
      originalReplaceState.apply(this, args);
      checkRoute();
    };

    // Cleanup
    return () => {
      window.removeEventListener('popstate', checkRoute);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  return (
    <>
      <Navbar />
      <App setShowFooter={setShowFooter} />
      {showFooter && <Footer />}
      <CookieConsent location="top">
        This website uses cookies to enhance the user experience.
      </CookieConsent>
      <ToastContainer />
    </>
  );
}

// 🔹 React 18: crea il root e renderizza
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);